<template>
  <!-- Footer -->
  <footer class="footer footer-seven">
    <div class="container footer-container">
      <div class="stay-tuned">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="footer-left-part pull-left">
              <h4>Newsletter</h4>
              <p>Be the first one to know about discounts, offers and events</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="footer-right-part">
              <form>
                <div class="form-group">
                  <div class="group-img">
                    <i class="feather-mail"></i>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter your email"
                    />
                    <button class="btn btn-primary" type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Top -->
    <div class="footer-top aos" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h2 class="footer-title">About</h2>
              <ul>
                <li>
                  <router-link to="about">About us</router-link>
                </li>
                <li>
                  <a href="javascript:void(0)">Pages</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Listing</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Category</a>
                </li>
                <li>
                  <a href="javascript:void(0)">In Press</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h2 class="footer-title">Support</h2>
              <ul>
                <li>
                  <router-link to="contact">Contact us</router-link>
                </li>
                <li>
                  <a href="javascript:void(0)">Online Chat</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Whatsapp</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Telegram</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Ticketing</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h2 class="footer-title">FAQ</h2>
              <ul>
                <li>
                  <a href="javascript:void(0)">Account</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Manage Deliveries</a>
                </li>
                <li>
                  <router-link to="service-details">Orders</router-link>
                </li>
                <li>
                  <a href="javascript:void(0)">Payments</a>
                </li>
                <li>
                  <router-link to="contact">Returns</router-link>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h2 class="footer-title">Category</h2>
              <ul>
                <li>
                  <a href="javascript:void(0)">Broast</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Pizza </a>
                </li>
                <li>
                  <a href="javascript:void(0)">Chicken</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Burgers</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Sandwiches</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget footer-menu">
              <h2 class="footer-title">Location</h2>
              <ul>
                <li>
                  <a href="javascript:void(0)">San Francisco </a>
                </li>
                <li>
                  <a href="javascript:void(0)"> London</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Tokyo</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Miami </a>
                </li>
                <li>
                  <a href="javascript:void(0)">Los Angeles</a>
                </li>
              </ul>
            </div>
            <!-- /Footer Widget -->
          </div>
          <div class="col-lg-2 col-md-6">
            <!-- Footer Widget -->
            <div class="footer-widget">
              <h2 class="footer-title">Contact Us</h2>
              <div class="footer-contact-info">
                <div class="footer-address">
                  <p class="footer-icon"><i class="fa-solid fa-phone"></i></p>
                  <p>(406) 555-0120</p>
                </div>
                <div class="footer-address">
                  <p class="footer-icon">
                    <i class="fa-solid fa-envelope"></i>
                  </p>
                  <p>listee@example.com</p>
                </div>
                <div class="footer-address">
                  <p class="footer-icon">
                    <i class="fa-solid fa-location-dot"></i>
                  </p>
                  <p>2972 Westheimer Rd. Santa Ana, Illinois 85486</p>
                </div>
              </div>
            </div>
            <!-- /Footer Widget -->
          </div>
        </div>

        <!-- Footer Counter Section-->
        <div class="footercount">
          <div class="row d-flex align-items-center">
            <div class="col-lg-4 col-md-6">
              <div class="vistors-details">
                <img src="@/assets/img/logo-new.png" alt="img" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="vistors-details text-lg-center">
                <div class="social-icon">
                  <ul>
                    <li>
                      <a href="#" target="_blank"
                        ><i class="fab fa-facebook-square"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank"
                        ><i class="fab fa-youtube"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" target="_blank"
                        ><i class="fab fa-dribbble"></i
                      ></a>
                    </li>
                    <li>
                      <a href="#" target="_blank"
                        ><i class="fab fa-figma"></i
                      ></a>
                    </li>
                    <li>
                      <a href="#" target="_blank"
                        ><i class="fab fa-whatsapp"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="vistors-details text-lg-end">
                <p>© 2023, All Rights Reserved</p>
              </div>
            </div>
          </div>
        </div>
        <!-- /Footer  Counter Section-->
      </div>
    </div>
    <!-- /Footer Top -->
  </footer>
  <!-- /Footer -->
</template>
